<template>
  <div class="border border-[#e5e7eb] rounded-[8px] overflow-hidden bg-white">
    <b-overlay
      :show="loadingData"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      class="w-full"
      rounded="sm"
    >
      <div class="table-responsive m-0">
        <table class="custom-ro-table w-full mb-0">
          <thead>
            <tr>
              <th
                rowspan="2"
                class="th-expedition"
              >
                Nama Ekspedisi
              </th>
              <th
                colspan="2"
                class="text-center min-w-[220px]"
              >
                Ekspedisi
              </th>
              <th
                colspan="2"
                class="text-center min-w-[220px]"
              >
                Pengguna
              </th>
              <th
                rowspan="2"
                class="th-action text-center"
              />
            </tr>
            <tr>
              <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                Cashback
              </th>
              <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                Biaya COD
              </th>
              <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                Cashback
              </th>
              <th class="text-center text-[12.5px] font-medium text-[#374151] px-[12px] py-[8px]">
                Biaya COD
              </th>
            </tr>
          </thead>
          <tbody v-if="listServices.length > 0">
            <template v-for="(item, idx) in listServices">
              <!-- Expedition Parent Row -->
              <tr
                :key="`expedition-${idx}`"
                class="expedition-row"
                @click="toggleExpand(item)"
              >
                <td>
                  <div class="flex items-center justify-between pr-[8px]">
                    <div class="flex items-center gap-[10px]">
                      <div class="inline-flex items-center justify-center w-[48px] h-[28px] bg-[#ffece9] rounded-full px-[8px] py-[3px]">
                        <img
                          :src="item.image_logo"
                          :alt="item.shipping_name"
                          class="max-h-[18px] max-w-[36px] object-contain"
                        >
                      </div>
                      <span class="text-[13.5px] font-semibold text-[#1f2937]">
                        {{ item.shipping_name }}
                      </span>
                    </div>
                    <feather-icon
                      :icon="isExpanded(item) ? 'ChevronDownIcon' : 'ChevronRightIcon'"
                      size="18"
                      class="text-[#4b5563]"
                    />
                  </div>
                </td>
                <td />
                <td />
                <td />
                <td />
                <td class="text-center td-action">
                  <button
                    type="button"
                    class="inline-flex items-center justify-center bg-transparent border-0 p-[4px] rounded-[6px] cursor-pointer text-[#6b7280] flex-shrink-0 transition-all duration-150 hover:text-[#f95031] hover:bg-[#ffece9] focus:outline-none"
                    title="Edit Biaya Ekspedisi"
                    @click.stop="changeExpeditionFee(item)"
                  >
                    <feather-icon
                      icon="EditIcon"
                      size="18"
                    />
                  </button>
                </td>
              </tr>

              <!-- Service Sub-rows (when expanded) -->
              <template v-if="isExpanded(item)">
                <tr
                  v-for="(service, sIdx) in item.services"
                  :key="`service-${idx}-${sIdx}`"
                  class="service-row"
                >
                  <td class="pl-[16px]">
                    <span class="inline-flex items-center gap-[6px] font-medium text-[#1f2937]">
                      <span class="text-[14px] leading-none text-[#1f2937]">•</span>
                      {{ service.service_name }}
                    </span>
                  </td>
                  <td class="text-center">
                    {{ formatPercent(service.cashback_from) }}
                  </td>
                  <td class="text-center">
                    {{ formatPercent(service.cod_fee_from) }}
                  </td>
                  <td class="text-center">
                    {{ formatPercent(service.cashback_to) }}
                  </td>
                  <td class="text-center">
                    {{ formatPercent(service.cod_fee_to) }}
                  </td>
                  <td class="td-action" />
                </tr>
              </template>
            </template>
          </tbody>
          <tbody v-else-if="!loadingData">
            <tr>
              <td
                colspan="6"
                class="text-center py-[16px] text-[#6b7280]"
              >
                Tidak Ada Data Untuk Ditampilkan
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'ROTableExpeditionsFee',
  props: {
    source: {
      type: String,
      default: 'komship',
    },
  },
  data() {
    return {
      loadingData: true,
      listServices: [],
      expandedExpeditions: [],
    }
  },
  watch: {
    source() {
      this.getListServices()
    },
  },
  mounted() {
    this.getListServices()
  },
  methods: {
    getListServices() {
      this.loadingData = true
      const params = {
        source: this.source,
      }
      const url = '/komship/api/v1/admin/shipment/configure/cost'

      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.listServices = data || []
          // Default first expedition expanded (matching screenshot where JNE is open)
          if (this.listServices.length > 0) {
            this.expandedExpeditions = [this.getExpeditionKey(this.listServices[0])]
          } else {
            this.expandedExpeditions = []
          }
          this.loadingData = false
        })
        .catch(err => {
          this.loadingData = false
          this.$toast_error({ message: 'Tidak mendapatkan list ekspedisi' })
        })
    },
    getExpeditionKey(item) {
      return item.shipping_name || item.id || item.shipping_id
    },
    isExpanded(item) {
      return this.expandedExpeditions.includes(this.getExpeditionKey(item))
    },
    toggleExpand(item) {
      const key = this.getExpeditionKey(item)
      const index = this.expandedExpeditions.indexOf(key)
      if (index > -1) {
        this.expandedExpeditions.splice(index, 1)
      } else {
        this.expandedExpeditions.push(key)
      }
    },
    formatPercent(val) {
      if (val === null || val === undefined || val === '') return ''
      return `${val}%`
    },
    changeExpeditionFee(expedition) {
      this.$router.push({
        name: 'edit-biaya-ekspedisi-ro',
        params: { ...expedition, source: this.source },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-ro-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 0;

  thead th {
    background-color: #f8f9fa !important;
    color: #1f2937 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    border: none !important;
    border-bottom: 1px solid #e5e7eb !important;
    border-right: 1px solid #e5e7eb !important;
    padding: 10px 14px !important;
    vertical-align: middle !important;
    text-transform: none !important;
  }

  thead th:last-child {
    border-right: none !important;
  }

  .th-expedition {
    width: 320px;
    min-width: 260px;
    text-align: left;
  }

  .th-action {
    width: 55px;
    min-width: 55px;
    position: sticky;
    right: 0;
    z-index: 11;
    background-color: #f8f9fa !important;
    box-shadow: -2px 0 6px -2px rgba(0, 0, 0, 0.08);
  }

  .td-action {
    width: 55px;
    min-width: 55px;
    position: sticky;
    right: 0;
    z-index: 9;
    box-shadow: -2px 0 6px -2px rgba(0, 0, 0, 0.08);
  }

  /* Expedition Parent Row */
  .expedition-row {
    background-color: #fff5f2 !important;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #ffede8 !important;
    }

    .td-action {
      background-color: #fff5f2 !important;
    }

    &:hover .td-action {
      background-color: #ffede8 !important;
    }

    td {
      padding: 9px 14px !important;
      vertical-align: middle !important;
      border: none !important;
      border-bottom: 1px solid #f3f4f6 !important;
      background-color: inherit;
    }
  }

  /* Service Sub-row */
  .service-row {
    transition: background-color 0.15s ease;

    &:hover td {
      background-color: #fafbfc !important;
    }

    .td-action {
      background-color: #ffffff !important;
    }

    &:hover .td-action {
      background-color: #fafbfc !important;
    }

    td {
      background-color: #ffffff;
      padding: 10px 14px !important;
      font-size: 13px !important;
      color: #1f2937;
      vertical-align: middle !important;
      border: none !important;
      border-bottom: 1px solid #f3f4f6 !important;
    }
  }

  @media (max-width: 768px) {
    .th-expedition {
      width: 240px;
      min-width: 200px;
    }
  }
}
</style>
